import {InjectionToken} from '@angular/core';

export const BASE_AUTH_PATH = new InjectionToken<string>('Base auth path');
